import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../../components/Products/ProductCard';
import UnifiedBookCard from '../../components/Books/UnifiedBookCard';
import { useDarkMode } from '../../context/DarkModeContext';
import { relatedMerchandise, recommendedBooks } from './data';
interface RelatedSectionProps {
  book: any;
}
export const RelatedSection = ({
  book
}: RelatedSectionProps) => {
  const {
    darkMode
  } = useDarkMode();
  return <div className="mb-8" data-id="element-7432" data-mp="1zwvhp2jgu4el">
      <div className="flex items-center justify-between mb-4" data-id="element-7433" data-mp="1v051mf7nv8t6">
        <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-7434" data-mp="1uxs8r70d7e1c">
          {book.coming_soon ? 'Pre-Order Merchandise' : 'Related Merchandise'}
        </h3>
        <Link to="/browse?type=merch" className={`font-medium transition-colors ${darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-500 hover:text-indigo-700'}`} data-id="element-7435" data-mp="24vy8pj2m2a3k">
          View all
        </Link>
      </div>
      <div className="hidden sm:grid sm:grid-cols-4 gap-6" data-id="element-7436" data-mp="163fw1kzckv2p">
        {relatedMerchandise.map(product => <ProductCard key={product.id} {...product} data-id="element-7437" data-mp="1b0pkaxb030oy" />)}
      </div>
      {/* Mobile Carousel */}
      <div className="sm:hidden relative" data-id="element-7438" data-mp="1ftqz75b7j08j">
        <div className="flex overflow-x-auto space-x-4 scrollbar-none pb-4" data-id="element-7439" data-mp="1futt7m3ttiso">
          {relatedMerchandise.map(product => <div key={product.id} className="flex-none w-[280px]" data-id="element-7440" data-mp="n4bt8tyefxjh">
              <ProductCard {...product} data-id="element-7441" data-mp="n64v7vy2htl5" />
            </div>)}
        </div>
        <div className={`absolute left-0 right-0 bottom-0 h-1 rounded-full ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`} data-id="element-7442" data-mp="s4zf717rto6u">
          <div className={`w-1/3 h-full rounded-full ${darkMode ? 'bg-indigo-500' : 'bg-indigo-200'}`} data-id="element-7443" data-mp="114310cybohp1" />
        </div>
      </div>
      {/* If you liked this section */}
      <div className={`pt-4 mt-6 border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'}`} data-id="element-7444" data-mp="2ciglr8xs4h0u">
        <h3 className="text-base font-semibold mb-3" data-id="element-7445" data-mp="cfpfwps3g2ai">If you liked this...</h3>
        <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide" data-id="element-7446" data-mp="8f5idl3lywnu">
          {recommendedBooks.map(recBook => <div key={recBook.id} className="flex-shrink-0 w-40" data-id="element-7447" data-mp="mewtne2qpyy5">
              <UnifiedBookCard book={recBook} data-id="element-7448" data-mp="hfk5mq04ultz" />
            </div>)}
        </div>
      </div>
    </div>;
};
export default RelatedSection;